import React from 'react';
import { Grid, InputAdornment } from '@mui/material';
import { ReferenceDto } from '../../../../services/dtos/reference.dto';
import SelectForm from '../../../commun/select-form';
import InputForm from '../../../commun/input-form';

//Props d'entrée de la fonction CreateAccountForm
type Props = {
    // Liste des civilités
    civilities: ReferenceDto[];
    // Le type d'interlocuteur est-il moral ?
    isMoral: boolean;
    // Gestion du loading lors de l'envoi
    validate: boolean;
    // Gestion du changement d'interlocuteur
    handleChangeInterlocutor: (interlocutor: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    // Liste des types d'interlocuteur
    interlocutorsSelection: { value: string; label: string }[];
};

/**
 * Fonction qui affiche la vue
 * @param civilities liste des civilités
 * @param interlocutors liste des interlocuteurs
 * @constructor
 */
function ContactDetailsForm({ civilities, isMoral, handleChangeInterlocutor, interlocutorsSelection }: Props) {
    //Retourne la vue grid avec tous les champs
    //Pour une PP : Affichage des champs nomNaissance, nomNaissance, prenom
    //Pour un PM : il n'y a pas de champ supplémentaire
    const autoCompleteFamilyName = 'family-name';
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                {/*champ interlocuteur*/}
                <SelectForm
                    required={true}
                    values={interlocutorsSelection}
                    handleChange={handleChangeInterlocutor}
                    id="interlocutors"
                    name="type"
                    label="Vous êtes un/une :"
                />
            </Grid>
            {/*is != PM : champ civilite*/}
            {/*is != PM : champ firstname*/}
            {/*is != PM : champ brithDate*/}
            {isMoral ? (
                <>
                    <Grid item xs={12} sm={6} />
                    <Grid item xs={12} sm={6}>
                        {/*Champ entree ou residence...*/}
                        <InputForm type="text" id="siret" name="siret" label="Siret" required />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/*Champ étage*/}
                        <InputForm
                            type="text"
                            id="raisonSociale"
                            name="raisonSociale"
                            label="Raison sociale"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/*Champ appartement*/}
                        <InputForm type="number" id="salaries" name="salaries" label="Nombre de salariés" required />
                    </Grid>
                    <Grid item xs={12} md={6} />
                </>
            ) : (
                <>
                    <Grid item xs={12} md={6}>
                        <SelectForm
                            required={true}
                            values={civilities}
                            id="civilities"
                            name="civilite"
                            label="Civilité"
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputForm
                            required
                            id="name"
                            name="nomUsage"
                            label="Nom"
                            autoComplete={autoCompleteFamilyName}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputForm required id="prenom" name="prenom" label="Prénom" autoComplete={'given-name'} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputForm
                            maxDate={new Date().toISOString().split('T')[0]}
                            required
                            id="brithDate"
                            name="dateNaissance"
                            label="Date de naissance"
                            type="date"
                            autoComplete={'bday'}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} />
                </>
            )}
            {/*champ mobilePhone*/}
            <Grid item xs={12} md={6}>
                <InputForm
                    id="mobilePhone"
                    name="telPort"
                    label="Téléphone portable"
                    type="tel"
                    InputProps={{
                        startAdornment: <InputAdornment position="start">0</InputAdornment>,
                    }}
                    autoComplete={'tel-national'}
                />
            </Grid>
            {/*champ telFixe*/}
            <Grid item xs={12} md={6}>
                <InputForm
                    id="phone"
                    name="telFixe"
                    label="Téléphone fixe"
                    type="tel"
                    InputProps={{
                        startAdornment: <InputAdornment position="start">0</InputAdornment>,
                    }}
                    autoComplete={'tel-national'}
                />
            </Grid>

            {/*champ mailPerso*/}
            <Grid item xs={12} md={6}>
                <InputForm required id="mailPerso" name="mail" label="Email" type="email" autoComplete={'email'} />
            </Grid>
            <Grid item xs={12} md={6} />
            {/*champ mailPro*/}
            <Grid item xs={12} md={6} sx={{ display: 'none' }}>
                <InputForm
                    id="mailPro"
                    name="mailPro"
                    label="Email professionnel"
                    type="email"
                    autoComplete={'email'}
                />
            </Grid>
        </Grid>
    );
}

export default ContactDetailsForm;
